import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"

const useListBu = () => {
    const [payload, setPayload] = useState([])
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [file, setSelectedFile] = useState(null)
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    const changePage = async (page) => {
        await getListBu(page)
        setPage(page)
    }

    const [limit, setLimit] = useState(10)
    const [filterName, setFilterName] = useState("")
    const [loadingPagestate, setLoadingPage] = useState(false)

    const setFilterNameUser = (e) => {
        setFilterName(e.target.value)
        setPage(1)
    }

    const setFilterLimit = (data) => {
        setLimit(data)
        setPage(1)
    }

    const getListBu = async (page) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.get(`/auth/business-units?page=${page}&limit=${limit}&name=${filterName}`)
            // console.log(res.data)
            if (res.status === 200) {
                setPayload(res.data.data)
                setTotalPage(res.data.paging.TotalPages)
                setLoadingPage(false)
                return res.data.data
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postBulkBu = async () => {
        try {
            setLoadingPage(true)
            const formData = new FormData();
            formData.append("excelFile", file)
            let res = await axiosInstance.post('/auth/business-units/upload', formData)
            if (res.status === 200) {
                toast.success("Success Add Business Unit")
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const deleteBusinessUnit = async (id) => {
        try {
            setLoadingPage(true)
            let res = await axiosInstance.delete(`/auth/business-units/${id}`)
            if (res.status === 204) {
                toast.success("Success Delete Business Unit")
                await getListBu(page)
            }
            setLoadingPage(false)
        } catch (error) {
            setLoadingPage(false)
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        getListBu,
        handleFileChange,
        postBulkBu,
        page,
        changePage,
        totalPage,
        deleteBusinessUnit,
        setFilterNameUser,
        limit,
        filterName,
        setFilterLimit,
        loadingPagestate
    }
}

export default useListBu